
import React from 'react';
import { Route } from 'react-router-dom';
import AppDashboard from '@/pages/app/AppDashboard';
import AppShop from '@/pages/app/AppShop';
import AppShopConcerns from '@/pages/app/AppShopConcerns';
import AppTreatments from '@/pages/app/AppTreatments';
import AppCredits from '@/pages/app/AppCredits';
import AppRewards from '@/pages/app/AppRewards';
import AppBook from '@/pages/app/AppBook';
import TreatmentDetail from '@/pages/app/TreatmentDetail';
import RoleProtectedRoute from '@/components/RoleProtectedRoute';

export const PatientRoutes = () => (
  <>
    {/* Patient Dashboard */}
    <Route 
      path="/app/patient/dashboard" 
      element={
        <RoleProtectedRoute allowedRoles={['customer', 'coordinator', 'admin']}>
          <AppDashboard />
        </RoleProtectedRoute>
      } 
    />
    
    {/* Patient Shop */}
    <Route 
      path="/app/patient/shop" 
      element={
        <RoleProtectedRoute allowedRoles={['customer', 'coordinator', 'admin']}>
          <AppShop />
        </RoleProtectedRoute>
      } 
    />
    
    {/* Patient Shop Concerns */}
    <Route 
      path="/app/patient/shop/concerns" 
      element={
        <RoleProtectedRoute allowedRoles={['customer', 'coordinator', 'admin']}>
          <AppShopConcerns />
        </RoleProtectedRoute>
      } 
    />
    
    {/* Patient Treatments */}
    <Route 
      path="/app/patient/treatments" 
      element={
        <RoleProtectedRoute allowedRoles={['customer', 'coordinator', 'admin']}>
          <AppTreatments />
        </RoleProtectedRoute>
      } 
    />
    
    {/* Treatment Detail */}
    <Route 
      path="/app/patient/treatments/:slug" 
      element={
        <RoleProtectedRoute allowedRoles={['customer', 'coordinator', 'admin']}>
          <TreatmentDetail />
        </RoleProtectedRoute>
      } 
    />
    
    {/* Patient Credits */}
    <Route 
      path="/app/patient/credits" 
      element={
        <RoleProtectedRoute allowedRoles={['customer', 'coordinator', 'admin']}>
          <AppCredits />
        </RoleProtectedRoute>
      } 
    />
    
    {/* Patient Rewards */}
    <Route 
      path="/app/patient/rewards" 
      element={
        <RoleProtectedRoute allowedRoles={['customer', 'coordinator', 'admin']}>
          <AppRewards />
        </RoleProtectedRoute>
      } 
    />
    
    {/* Patient Book */}
    <Route 
      path="/app/patient/book" 
      element={
        <RoleProtectedRoute allowedRoles={['customer', 'coordinator', 'admin']}>
          <AppBook />
        </RoleProtectedRoute>
      } 
    />
  </>
);
